<template>
  <div id="app">
    <div id="nav">
      <sd-logo></sd-logo>
      <div v-if="!modelLabel"
           class="links manual-list__links">
        <button class="sd-button sd-button_no-bg_sm">
          <a href="https://swissdelta.com/about"><h5>About</h5></a>
        </button>
        <button class="sd-button sd-button_no-bg_sm">
          <a href="https://swissdelta.com/shop"><h5>Shop</h5></a>
        </button>
        <button class="sd-button sd-button_no-bg_sm">
          <a href="https://swissdelta.com/shop"><h5>Support</h5></a>
        </button>
      </div>
      <div class="test-drive-label" v-else>
        <div class="label__model-name">
          <div v-if="modelLabel.name" v-text="modelLabel.name"></div>
          <div v-text="modelLabel.modelNumber"></div>
        </div>
        <div class="label__current-tutorial">
          <h2 v-text="tutorialLabel"></h2>
        </div>
      </div>
      <div class="links" v-if="$route.name === 'productManual'">
        <button class="sd-button sd-button_no-bg_sm">
          <router-link :to="{name: 'Manual'}" class="back-to-manuals"><h5>Back</h5></router-link>
        </button>
      </div>
    </div>
    <router-view @product-model="updateModel" @current-tutorial="updateTutorial"/>
  </div>
</template>
<script>
  import sdLogo from '@/components/Logo';

  export default {
    name: 'App',
    components: {
      sdLogo
    },
    data () {
      return {
        model: undefined,
        tutorial: undefined
      }
    },
    computed: {
      modelLabel () {
        if (this.$route.name !== 'productManual') {
          this.model = undefined
          return false
        }
        else if (this.model !== undefined) return {
          name: this.model.fields.name,
          modelNumber: this.model.fields.slug.toUpperCase()
        }
        else if (this.$route.name === 'productManual' && this.$route.params) return {
          name: this.$route.params.title,
          modelNumber: this.$route.params.modelName
        }
      },
      tutorialLabel () {
        if (this.$route.name !== 'productManual') {
          this.tutorial = undefined
          return false
        }
        else if (this.tutorial !== undefined) return this.tutorial.title
      }
    },
    methods: {
      updateModel (data) {
        this.model = data
      },
      updateTutorial (data) {
        this.tutorial = data
      }
    }
  }
</script>
<style lang="scss">
  @import './styles/elements';
  @import './styles/layout';
  @import './styles/mixins';
  @import './styles/typography';
  @import './styles/variables';

  html, body {
    margin: 0;
    box-sizing: border-box;
    background: goldenrod;
  }
  *, *:before, *:after {
    box-sizing: inherit;
  }
  #app {
    background: goldenrod;
  }
  #nav {
    z-index: 20;
    position: relative;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    background: white;
    padding: 12px 12px 0;
    margin: 12px 12px 0;
    box-shadow: 0 0 0 12.5px white;
  }
  .links {
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-end;
    align-items: baseline;
    * {
      cursor: pointer;
      text-align: right;
    }
    * + * {
      margin-left: 36px;
    }
    &.manual-list__links {
      margin-left: auto;
    }
  }
  .test-drive-label {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    align-items: center;
    width: fit-content;
    margin: 0 12px;
  }
  .label__model-name {
    display: flex;
    flex-flow: column nowrap;
    justify-content: space-between;
    align-items: stretch;
    width: fit-content;
    & > * {
      flex: 1 1 100%;
      text-align: center;
    }
    & > :first-child,
    & > :first-child:last-child {
      //@extend .sd-h_5;
      @extend .sd-h_2;
    }
    & > :last-child {
      //@extend .sd-h_6;
      @extend .sd-h_3;
    }
  }
  .label__current-tutorial {
    flex: 1 1 auto;
    margin-left: 12px;
    & > * {
      text-align: left;
    }
  }
  @media all and (max-width: #{$sd-vw_xs - 1}) {
    #nav {
      flex-flow: row wrap;
    }
    .swiss-delta-logo {
      order: 1;
      margin: 0 auto;
    }
    .links {
      order: 3;
      flex: 1 1 auto;
      justify-content: center;
      & > :first-child {
        margin-left: auto;
      }
      &.manual-list__links {
        display: none;
      }
    }
    .test-drive-label {
      order: 2;
      flex: 1 1 (200% / 3);
      margin: 0;
      justify-content: flex-start;
      flex-flow: column nowrap;
    }
    .label__model-name {
      width: auto;
      flex: 1 1 auto;
      flex-flow: column nowrap;
      justify-content: flex-start;
      & > * {
        flex: 0 0 auto;
        text-align: center;
      }
    }
    .label__current-tutorial {
      margin-left: 0;
      & > * {
        text-align: center;
      }
    }
  }
  @media all and (min-width: $sd-vw_xs) and (max-width: #{$sd-vw_sm - 1}) {
    .label__model-name :first-child,
    .label__model-name :last-child {
      text-align: right;
    }
    .label__current-tutorial {
      margin-left: 12px;
    }
  }
  @media all and (min-width: $sd-vw_sm) {
    #nav {
      padding: 24px 24px 0;
    }
    .test-drive-label {
      flex-flow: row nowrap;
      margin: 0 24px;
    }
    .label__model-name {
      flex: 1 1 auto;
      flex-flow: row nowrap;
      align-items: baseline;
      & > * {
        flex: 1 1 auto;
      }
      * + * {
        margin-left: 12px;
      }
      & > :first-child {
        text-align: right;
      }
      & > :last-child {
        text-align: left;
      }
    }
    .label__current-tutorial,
    .label__current-tutorial h2 {
      flex: 1 1 auto;
      min-width: max-content;
    }
  }
</style>
